import { useField } from 'formik'
import { useBrandKit } from 'hooks/queries/brandKits/useBrandKit'

export const useFormBrandVisualKit = () => {
  const [{ value: brandKitId }, ,] = useField('brand_kit_id')
  const brandKit = useBrandKit(brandKitId, { enabled: Boolean(brandKitId) }).data?.brand_kit

  return brandKit?.brand_visual_kit
}
